export default "__VITE_ASSET__D$C6TAlu__"